import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, FormControl, FormHelperText,
    Step, StepContent, StepLabel, Stepper,
    Tooltip
} from "@mui/material";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import MDButton from "../../components/MDButton";
import React, {useEffect, useMemo, useState} from "react";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {useDispatch, useSelector} from "react-redux";
import {Logout, onErrorAlert, onSuccessAlert} from "../../actions";
import {noop} from "lodash";
import {useNavigate} from "react-router-dom";
import {MaterialReactTable, useMaterialReactTable} from "material-react-table";
import Papa from 'papaparse';
import * as XLSX from "xlsx";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SaveIcon from '@mui/icons-material/Save';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import LocalStorage from "../../utils/LocalStorage";
import {useTranslation} from "react-i18next";
import Icon from "@mui/material/Icon";
import {MRT_Localization_EN} from "material-react-table/locales/en";
import {MRT_Localization_ZH_HANS} from "material-react-table/locales/zh-Hans";
import {MRT_Localization_FR} from "material-react-table/locales/fr";
import {countriesForCustomerImport, emailValidation} from "../../constants";
import {downloadCustomerImportTemplate, importCustomerList} from "../../actions/customer/customerAction";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "../../components/MDInput";
import {ownerSelected} from "../../actions/inventory/inventoryAction";
import {useDebounce} from "use-debounce";
import {LoadingButton} from "@mui/lab";

const CustomerImportDialog = ({isImportOpen,setIsImportOpen,customerFilter,saveFormData,onSearchSuccess,setLoading}) => {

    const [activeStep, setActiveStep] = React.useState(0);
    const dispatch = useDispatch()
    const nav = useNavigate()
    const [data,setData] = useState([])
    const [isLoading,setIsLoading] = useState(false)
    const [isSaving,setIsSaving] = useState(false)
    const [jsonData, setJsonData] = useState([]);
    const [fileName, setFileName] = useState("");
    const warehouseList = useSelector(state => state?.inventory?.warehouseList,(prev, next) => prev === next)
    const [rowSelection, setRowSelection] = useState({});
    const [editedData, setEditedData] = useState({});
    const [editMode,setEditMode] = useState(true)
    const [currentDeletedObject,setCurrentDeletedObject] = useState({})
    const [isAlertOpen,setIsAlertOpen] = useState(false)
    const languageSelect = useSelector(state => state?.common?.language,(prev, next) => prev === next)
    const {t, i18n} = useTranslation();
    const [ownerList ,setOwnerList] =useState([])
    const [inputOwnerValue,setInputOwnerValue] = useState()
    const [ownerValue] = useDebounce(inputOwnerValue, 400);
    const [ownerId, setOwnerId] = useState(null)
    const [loadingButtonState,setLoadingButtonState] = useState(false)
    const steps = [
        {
            label: t('ProductPage..XLSX Template'),
            description: t("CustomerPage.Click the button to download customer template file. Please don't add more columns"),
        },
        {
            label: t('CustomerPage.Import .XLSX File'),
            description: t('ProductPage.click the button to import .xlsx'),
        },

    ];
    const handleNext = (index) => {
        if(index === steps.length - 1) {
            setIsImportOpen(false)
            handleReset()
            setActiveStep(0)
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }

    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setOwnerId(null)
        setData([])
        setJsonData([])
        setEditedData({})
        setEditMode(true)
    };

    const handleDownload = () => {
        dispatch(downloadCustomerImportTemplate(onUrlSuccess,onError))
    }

    const onUrlSuccess = (msg) => {
        dispatch(onSuccessAlert(`${t("CustomerPage.download")} ${msg} ${t("CustomerPage.successfully")}`))

    }

    const onError = (msg, code) => {
        setLoadingButtonState(false)
        dispatch(onErrorAlert((msg)))
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    useEffect(()=>{


        if(ownerValue){
            const axiosPost = async () => {
                await dispatch(ownerSelected({condition: ownerValue, userName: LocalStorage.getItem('username')}, (data)=>setOwnerList(data)))
            }
            axiosPost().then()
        } else {
            setOwnerList([])
        }
    },[ownerValue])

    const parseCsv = (file) => {
        Papa.parse(file, {
            header: true, // 使用第一行为 JSON 的键
            skipEmptyLines: true, // 跳过空行
            complete: (result) => {
                setJsonData(result.data); // 保存解析后的 JSON 数据
            },
            error: (error) => {
                console.error(t("CustomerPage.Error parsing CSV") + ":", error);
            },
        });
    };

    const parseXlsx = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const parsedData = XLSX.utils.sheet_to_json(worksheet);

            setJsonData(parsedData); // 保存解析后的 JSON 数据
        };
        reader.readAsArrayBuffer(file);
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        setFileName(file.name); // 保存文件名
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (fileExtension === "csv") {
            parseCsv(file);
        } else if (fileExtension === "xlsx") {

            parseXlsx(file);
        } else {
            dispatch(onErrorAlert(t("CustomerPage.Unsupported file type")));
        }

        event.target.value = "";
    };

    const [validationErrors, setValidationErrors] = useState({});

    useEffect(()=>{
        if(!isImportOpen){
            handleReset()
            setActiveStep(0)
        }

    },[isImportOpen])

    useEffect(() => {
        let newData = jsonData.filter(item =>
            !!item["Owner ID*"] ||
            !!item["Customer Name*"] ||
            !!item["Email Address*"] ||
            !!item["Address Line #1*"]
        );

        if (LocalStorage.getItem('role') === 'admin') {
            setData(newData.map((item, index) => ({
                id: index + 1, // 添加新的 id 属性
                ownerId: item["Owner ID*"] ? String(item["Owner ID*"]).trim() : "",
                customerId: item["Customer ID*"] ? String(item["Customer ID*"]).trim() : "",
                customerName: item["Customer Name*"] ? String(item["Customer Name*"]).trim() : "",
                phoneNumber: item["Phone Number*"] ? String(item["Phone Number*"]).trim() : "",
                emailAddress: item["Email Address*"] ? String(item["Email Address*"]).trim() : "",
                addressLine1: item["Address Line #1*"] ? String(item["Address Line #1*"]).trim() : "",
                addressLine2: item["Address Line #2"] ? String(item["Address Line #2"]).trim() : "",
                city: item["City*"] ? String(item["City*"]).trim() : "",
                province: item["Province/State*"] ? String(item["Province/State*"]).trim() : "",
                postCode: item["Post/Zip Code*"] ? String(item["Post/Zip Code*"]).trim() : "",
                country: item["Country*"] ? String(item["Country*"]).trim() : "",
                isDefault: item["isDefault*"] ? String(item["isDefault*"]).trim() : "",
            })));
        } else {
            setData(newData.map((item, index) => ({
                id: index + 1, // 添加新的 id 属性
                ownerId: LocalStorage.getItem('ownerId') || "",
                customerId: item["Customer ID*"] ? String(item["Customer ID*"]).trim() : "",
                customerName: item["Customer Name*"] ? String(item["Customer Name*"]).trim() : "",
                phoneNumber: item["Phone Number*"] ? String(item["Phone Number*"]).trim() : "",
                emailAddress: item["Email Address*"] ? String(item["Email Address*"]).trim() : "",
                addressLine1: item["Address Line #1*"] ? String(item["Address Line #1*"]).trim() : "",
                addressLine2: item["Address Line #2"] ? String(item["Address Line #2"]).trim() : "",
                city: item["City*"] ? String(item["City*"]).trim() : "",
                province: item["Province/State*"] ? String(item["Province/State*"]).trim() : "",
                postCode: item["Post/Zip Code*"] ? String(item["Post/Zip Code*"]).trim() : "",
                country: item["Country*"] ? String(item["Country*"]).trim() : "",
                isDefault: item["isDefault*"] ? String(item["isDefault*"]).trim() : "",
            })));
        }
    }, [jsonData]);




    const handleDelete = (row) => {

        setCurrentDeletedObject(row.original)
        setIsAlertOpen(true)

        // setData(data.filter(item=>item.id !== row.id))
    }

    function validateSafeNum(value) {

        const num = Number(value);
        return !isNaN(num) && Number.isInteger(num) && num > 0;
    }
    function validateData(data) {
        return {
            ownerId: !validateRequired(data.ownerId) ? t('CustomerPage.Owner Id is Required') : '',
            customerId: !validateRequired(data.customerId) ? t('CustomerPage.Customer ID is Required') : '',
            customerName: !validateRequired(data.customerName) ? t('CustomerPage.Customer Name is Required') : '',
            phoneNumber: !validateRequired(data.phoneNumber) ? t('CustomerPage.Phone Number is Required') : '',
            emailAddress: !validateRequired(data.emailAddress) ? t('CustomerPage.Email Address is Required') : '' || !emailValidation(data.emailAddress) ? t('CustomerPage.Email address is invalid') : '',
            addressLine1: !validateRequired(data.addressLine1) ? t('CustomerPage.Address Line #1 is Required') : '',
            city: !validateRequired(data.city) ? t('CustomerPage.City is Required') : '',
            province: !validateRequired(data.province) ? t('CustomerPage.Province/State is Required') : '',
            postCode: !validateRequired(data.postCode) ? t('CustomerPage.Post/Zip Code is Required') : '',
            country: !validateRequired(data.country) ? t('CustomerPage.Country is Required') : '',
            isDefault: !validateRequired(data.isDefault) ? t('CustomerPage.isDefault is Required') : '',
        };
    }

    useEffect(() => {
        setEditedData({})
        if (data.length > 0) {
            const newValidationErrors = {};

            // 遍历数据，逐行验证
            data.forEach((row, index) => {
                // 1. 基础验证：检查必填字段和 safeNum
                const userErrors = validateData(row);
                Object.entries(userErrors).forEach(([key, error]) => {
                    if (error) {
                        newValidationErrors[`${row.id}-${key}`] = error;
                    }
                });
                if (checkPermission(PERMISSION_DICT.QueryOwnerInfo) && row.ownerId !== ownerId?.ownerId){
                    newValidationErrors[`${row.id}-ownerId`] = t("CustomerPage.Owner ID does not match the selected owner");
                }

                // 2. 检查 customer name  和 customer Id 的冲突条件
                data.forEach((compareRow, compareIndex) => {
                    if (
                        index !== compareIndex && // 排除自己与自己比较
                        row.ownerId === compareRow.ownerId && // ownerId 相同
                        row.customerId === compareRow.customerId && // customerId 相同
                        (row.customerName !== compareRow.customerName)
                    ) {
                        // 将后者添加到验证错误中
                        newValidationErrors[`${compareRow.id}-customerName`] = t("CustomerPage.Each customer ID can be associated with only one customer name");
                    }
                });

                // 3. 检查 customer id 和 isDefault 的冲突条件
                data.forEach((compareRow, compareIndex) => {
                    if (
                        index !== compareIndex && // 排除自己与自己比较
                        row.ownerId === compareRow.ownerId && // ownerId 相同
                        row.customerId === compareRow.customerId && // customerId 相同
                        (row.isDefault === "Yes" && compareRow.isDefault === "Yes") //多个默认地址
                    ) {
                        // 将后者添加到验证错误中
                            newValidationErrors[`${compareRow.id}-isDefault`] = t("CustomerPage.Only one address can be set as the default for the same customer");
                    }
                });

                // 4. 检查同一 owner 下 addressLine1 重复
                data.forEach((compareRow, compareIndex) => {
                    if (
                        index !== compareIndex &&                     // 排除自己
                        row.ownerId === compareRow.ownerId &&         // 同一个 owner
                        row.customerId === compareRow.customerId && // customerId 相同
                        row.addressLine1 === compareRow.addressLine1  // addressLine1 相同
                    ) {
                        newValidationErrors[`${compareRow.id}-addressLine1`] =
                            t("CustomerPage.Address Line #1 must be unique for the same owner");
                    }
                });


            });

            setValidationErrors(newValidationErrors);
        }
    }, [data]);




    const columns = [
        {
            accessorKey: "id",
            header: t("CustomerPage.LineNo"),
            enableEditing: false,
            size: 80,
        },
        {
            accessorKey: "ownerId",
            header: (
                <span>
                {t("CustomerPage.Owner ID")}
                    <span style={{ color: "red" }}>*</span>
            </span>
            ),
            size: 90,
            enableEditing: editMode && LocalStorage.getItem('role') === 'admin',
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                type: "text",
                required: true,
                placeholder: t("CustomerPage.Enter Owner ID"),
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
        {
            accessorKey: "customerId",
            header: (
                <span>
                {t("CustomerPage.Customer ID")}
                    <span style={{ color: "red" }}>*</span>
            </span>
            ),
            size: 150,
            enableEditing: editMode,
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                type: "text",
                required: true,
                placeholder: t("CustomerPage.Enter Customer ID"),
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
        {
            accessorKey: "customerName",
            header: (
                <span>
                {t("CustomerPage.Customer Name")}
                    <span style={{ color: "red" }}>*</span>
            </span>
            ),
            size: 150,
            enableEditing: editMode,
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                type: "text",
                required: true,
                placeholder: t("CustomerPage.Enter Customer Name"),
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
        {
            accessorKey: "phoneNumber",
            header: (
                <span>
                {t("CustomerPage.Phone Number")}
                    <span style={{ color: "red" }}>*</span>
            </span>
            ),
            size: 100,
            enableEditing: editMode,
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                type: "text",
                required: true,
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                placeholder: t("CustomerPage.Enter Phone Number"), // 默认占位符
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
        {
            accessorKey: "emailAddress",
            header: (
                <span>
                {t("CustomerPage.Email Address")}
                    <span style={{ color: "red" }}>*</span>
            </span>
            ),
            size: 150,
            enableEditing: editMode,
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                type: "text",
                required: true,
                placeholder: t("CustomerPage.Enter Email Address"),
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
        {
            accessorKey: "addressLine1",
            header: (
                <span>
                {t("CustomerPage.Address Line #1")}
                    <span style={{ color: "red" }}>*</span>
            </span>
            ),
            size: 150,
            enableEditing: editMode,
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                type: "text",
                required: true,
                placeholder: t("CustomerPage.Enter Address Line #1"),
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
        {
            accessorKey: "addressLine2",
            header: t("CustomerPage.Address Line #2"),
            size: 150,
            enableEditing: editMode,
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                type: "text",
                required: true,
                placeholder: t("CustomerPage.Enter Address Line #2"),
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
        {
            accessorKey: "city",
            header: (
                <span>
                {t("CustomerPage.City")}
                    <span style={{ color: "red" }}>*</span>
            </span>
            ),
            size: 100,
            enableEditing: editMode,
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                type: "text",
                required: true,
                placeholder: t("CustomerPage.Enter City"),
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
        {
            accessorKey: "province",
            header: (
                <span>
                {t("CustomerPage.Province")}
                    <span style={{ color: "red" }}>*</span>
            </span>
            ),
            size: 100,
            enableEditing: editMode,
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                type: "text",
                required: true,
                placeholder: t("CustomerPage.Enter Province"),
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
        {
            accessorKey: "postCode",
            header: (
                <span>
                {t("CustomerPage.Post/Zip Code")}
                    <span style={{ color: "red" }}>*</span>
            </span>
            ),
            size: 100,
            enableEditing: editMode,
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                type: "text",
                required: true,
                placeholder:t("CustomerPage.Enter Post/Zip Code"),
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
        {
            accessorKey: "country",
            header: (
                <span>
                {t("CustomerPage.Country")}
                    <span style={{ color: "red" }}>*</span>
            </span>
            ),
            editVariant: "select",
            editSelectOptions: countriesForCustomerImport,
            enableEditing: editMode,
            size: 90,
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                select: true,
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                placeholder: t("CustomerPage.Select Country"),
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
        {
            accessorKey: "isDefault",
            header: (
                <span>
                {t("CustomerPage.Is Default")}
                    <span style={{ color: "red" }}>*</span>
            </span>
            ),
            editVariant: "select",
            editSelectOptions: ["Yes","No"],
            enableEditing: editMode,
            size: 110,
            muiTableBodyCellProps: ({ cell }) => ({
                className: validationErrors[`${cell.row.id}-${cell.column.id}`] ? "error" : "",
            }),
            muiEditTextFieldProps: ({ cell, row }) => ({
                select: true,
                error: !!validationErrors[`${cell.row.id}-${cell.column.id}`],
                helperText: validationErrors[`${cell.row.id}-${cell.column.id}`],
                placeholder: t("CustomerPage.Select Is Default"),
                onBlur: (event) => {
                    const inputValue = event.target.value;
                    setEditedData((prev) => ({
                        ...prev,
                        [row.id]: {
                            ...prev[row.id], // 保留已有的编辑数据
                            [cell.column.id]: inputValue, // 更新当前编辑的数据
                        },
                    }));
                },
            }),
        },
    ];

    const validateRequired = (value) => {
        return !!value && value.length > 0;
    };

    const handleUpdateData = () => {
        setData((prevData) =>
            prevData.map((item) =>
                editedData[item.id] ? { ...item, ...editedData[item.id] } : item
            )
        );
        setEditedData({}); // 清空编辑数据
    };
    const handleSubmit = async () => {
        setEditedData({})
        let formData = {}
        let arr = data.map(item => ({
            // ...item,
            lineNo: item.id,
            ownerId:item.ownerId,
            customerId:item.customerId,
            customerName:item.customerName,
            phoneNumber:item.phoneNumber,
            emailAddress:item.emailAddress,
            address1:item.addressLine1,
            address2:item.addressLine2,
            city:item.city,
            province:item.province,
            zipCode:item.postCode,
            country:item.country,
            isDefault:item.isDefault,


        }));

        formData.ownerId = ownerId?.ownerId
        formData.batchImportCustomerList = [...arr]
        setLoadingButtonState(true)
        await dispatch(importCustomerList(formData, onImportFeedback,onError))

    }

    const handleChooseFile = () => {
        if(editMode){
            document.getElementById('fileInput').click()
        } else {
            setOwnerId(null)
            setData([])
            setJsonData([])
            setEditedData({})
            setEditMode(true)
            document.getElementById('fileInput').click()
        }

    }

    const onImportFeedback = (fb) => {
        setLoadingButtonState(false)
        if(fb?.exceptionFlag && fb?.customerRespDTOS.length > 0){
            let result = fb?.customerRespDTOS.reduce((acc, {lineNo, message}) => {
                const keyPrefix = message.split(':')[0] // 分割 message
                const trimmedMessage = message.split(':')[1]?.trim(); // 分割 message 并取第二部分，去除前后空格
                const key = `${lineNo}-${keyPrefix}`; // 使用小写的前缀构建键
                acc[key] = trimmedMessage?trimmedMessage:t("Invalid Input"); // 使用去除前缀后的 message 作为值
                return acc;
            }, {});

            setValidationErrors(result)

        }else if(!fb?.exceptionFlag){
            dispatch(onSuccessAlert(t('CustomerPage.Import Customer successfully')))
            setEditMode(false)
            const axiosPost = async () => {
                setLoading(true)
                await dispatch(customerFilter(saveFormData(),onSearchSuccess,onError))
            }
            axiosPost().then()
        }
    }



    const table = useMaterialReactTable({
        columns,
        data,
        enableTopToolbar:false,
        enableKeyboardShortcuts: false,
        enableColumnActions: false,
        enableColumnFilters: false,
        enablePagination: false,
        enableSorting: false,
        enableStickyHeader: true,
        createDisplayMode: 'row', // ('modal', and 'custom' are also available)
        editDisplayMode: 'cell', // ('modal', 'row', 'table', and 'custom' are also available)
        enableCellActions: true,
        enableClickToCopy: 'context-menu',
        enableColumnPinning: true,
        enableEditing: true,
        enableRowActions: true,
        enableRowSelection: false,
        localization:languageSelect === 'en'?MRT_Localization_EN:languageSelect === 'zh'?MRT_Localization_ZH_HANS:MRT_Localization_FR,
        getRowId: (row) => row.id,

        muiTableContainerProps: ({ table }) => ({
            sx: {
                maxHeight: table.getState().isFullScreen ?  undefined:400,
            },
        }),
        muiTableBodyCellProps:({ table }) => ({

            sx: (theme) => ({
                height:'30px',
                paddingTop:0,
                paddingBottom:0
            }),
            onClick: (event) => { event.preventDefault();}
        }),

        onCreatingRowCancel: () => setValidationErrors({}),
        // onCreatingRowSave: handleCreateUser,
        renderRowActions: ({ row }) => (
            <MDBox sx={{ display: 'flex', gap: '1rem' }}>
                <Tooltip title={t("Delete")}>
                    <IconButton color="error"
                                disabled={loadingButtonState || !editMode}
                                onClick={() => {
                                    if(loadingButtonState !== true) {
                                        handleDelete(row)
                                    }}}
                                // onClick={()=>handleDelete(row)}
                                size={'small'}
                                // disabled={!editMode}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </MDBox>
        ),
        renderBottomToolbarCustomActions: () => (
            <MDBox sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                { data.length > 0 && (Object.keys(validationErrors).length !== 0 || Object.keys(editedData).length !== 0 ) && editMode && <MDButton
                    color="error"
                    variant="contained"
                    onClick={handleUpdateData} // 这里调用更新数据的方法
                    disabled={Object.keys(editedData).length === 0}
                    startIcon={<SaveIcon />}
                >
                    {t('Save')}
                </MDButton>}
                { (data.length > 0 && Object.keys(validationErrors).length === 0 && editMode && Object.keys(editedData).length === 0) &&
                //     <MDButton
                //     color="primary"
                //     variant="contained"
                //     onClick={handleSubmit} // 这里调用更新数据的方法
                //     startIcon={<FileUploadIcon />}
                // >
                //     {t('Import')}
                // </MDButton>
                    <LoadingButton
                        //loading
                        // name="action"
                        // value="saveAndSubmit"
                        variant={'contained'}
                        disabled={loadingButtonState}
                        loading={loadingButtonState}
                        onClick={handleSubmit}
                        sx={{display: 'block', backgroundColor: '#3F50B5', // 设置背景颜色
                            '&:hover': {
                                backgroundColor: '#3F50B5', // 悬停时保持相同颜色
                            },}}>
                        {t('Import')}
                    </LoadingButton>

                }
                {data.length > 0 && Object.keys(validationErrors).length !== 0 && <MDTypography variant={'h6'} color="error">{t('ProductPage.Click the red cell to fix errors and press SAVE button before importing')}</MDTypography>}
                {!editMode && <MDTypography variant={'h6'} color="success">{`${t('Updated')} ${data.length} ${t('CustomerPage.records of customer info successfully')}`}</MDTypography>}
            </MDBox>
        ),
        // renderTopToolbarCustomActions: ({ table }) => (
        //     <MDButton
        //         variant="contained"
        //         onClick={handleFileUpload}>
        //     >
        //         Import CSV File
        //     </MDButton>
        // ),
        initialState: {
            density: 'compact',
            columnPinning: {
                right: ['mrt-row-actions'],
            },
        },
        state: {
            isLoading: isLoading,
            isSaving: isSaving,
            rowSelection
            // showAlertBanner: isLoadingUsersError,
            // showProgressBars: isFetchingUsers,
        },
        onRowSelectionChange:setRowSelection,
    });
    return(<React.Fragment>
        <Dialog
            open={isImportOpen}
            onClose={(event, reason) => {
                if(loadingButtonState !== true) {
                    setIsImportOpen(false)
                }
            }}
            // onClose={() => {setIsImportOpen(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'xxs'}
        >
            <DialogTitle id="alert-dialog-title" style={{cursor: 'move', display: 'flex', justifyContent: 'space-between',paddingBottom:"0px"}}>
                <div>{t("CustomerPage.Import Owner Customers Info")}</div>
                <IconButton size="large"
                            disabled={loadingButtonState}
                            onClick={() => {
                                if(loadingButtonState !== true) {
                                    setIsImportOpen(false)
                                }
                            }}
                >
                    <Icon>cancel</Icon>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <MDBox display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                        <Stepper activeStep={activeStep} orientation="vertical">
                            {steps.map((step, index) => (
                                <Step key={step.label}>
                                    <StepLabel
                                        optional={
                                            index === steps.length - 1 ? (
                                                <MDTypography variant="caption">{t('Last step')}</MDTypography>
                                            ) : null
                                        }
                                    >
                                        {step.label}
                                    </StepLabel>
                                    <StepContent>
                                        <MDTypography variant={'h6'}>{step.description}</MDTypography>
                                        {
                                            activeStep === 0 &&
                                            <MDButton
                                                color={'warning'}
                                                variant="contained"
                                                startIcon={<FileDownloadIcon />}
                                                onClick={handleDownload}
                                            > {t('Download')}</MDButton>
                                        }
                                        {
                                            activeStep === 1 &&
                                            <div>
                                                <MDBox mt={2} mb={2} sx={{display: 'flex', justifyContent: 'flex-star'}}>
                                                    <MDBox>
                                                        {
                                                            checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&
                                                            <MDBox width="400px">
                                                                <FormControl fullWidth>
                                                                    <Autocomplete
                                                                        required
                                                                        disablePortal={false}
                                                                        options={ownerList}
                                                                        disableClearable
                                                                        // readOnly={type === 'Preview'}
                                                                        getOptionLabel={(option) => `ID: ${option?.ownerId} Name: ${option?.ownerName}`}
                                                                        isOptionEqualToValue={(option, value) => option?.ownerId === value?.ownerId}
                                                                        value={ownerId}
                                                                        onChange={(e, v) => setOwnerId(v)}
                                                                        onInputChange = {(event, newInputValue)=> setInputOwnerValue(newInputValue)}
                                                                        renderInput={(params) =>
                                                                            <MDInput
                                                                                {...params}
                                                                                label={t("CustomerPage.Owner")}
                                                                                required
                                                                                InputLabelProps={{ shrink: true }}
                                                                            />}
                                                                    />
                                                                    <FormHelperText
                                                                        sx={{ fontWeight: 'medium' }}></FormHelperText>
                                                                </FormControl>
                                                            </MDBox>
                                                        }
                                                    </MDBox>
                                                    {
                                                        (checkPermission(PERMISSION_DICT.QueryOwnerInfo) ? !!ownerId : true ) &&
                                                        <MDBox ml={2}>
                                                            <input
                                                                id="fileInput"
                                                                type="file"
                                                                accept=".csv, .xlsx"
                                                                style={{display: 'none'}}
                                                                onChange={handleFileUpload}
                                                            />
                                                            <MDButton
                                                                variant="contained"
                                                                color="primary"
                                                                startIcon={<AttachFileIcon/>}
                                                                disabled={loadingButtonState}
                                                                onClick={() => {
                                                                if(loadingButtonState !== true) {
                                                                    handleChooseFile()
                                                                }}}
                                                            >
                                                                {t('Choose File')}
                                                            </MDButton>
                                                        </MDBox>
                                                    }
                                                    <MDBox>
                                                        <MDButton sx={{marginLeft: 1}} color="secondary" variant="outlined"
                                                                  startIcon={<CleaningServicesIcon/>}
                                                                  disabled={loadingButtonState}
                                                                  onClick={() => {
                                                                      if(loadingButtonState !== true) {
                                                                          handleReset()
                                                                      }}}
                                                                  >
                                                            {t('reset')}
                                                        </MDButton>
                                                    </MDBox>
                                                </MDBox>
                                                { data !== []
                                                    // && (checkPermission(PERMISSION_DICT.QueryOwnerInfo) ? !!ownerId : true )
                                                    && <MaterialReactTable table={table}/>}

                                            </div>


                                        }
                                        <MDBox sx={{ mb: 2 }}>
                                            <MDButton
                                                color={'info'}
                                                variant="text"
                                                disabled={loadingButtonState}
                                                onClick={() => {
                                                    if(loadingButtonState !== true) {
                                                        handleNext(index)
                                                    }}}
                                                sx={{ mt: 1, mr: 1 }}
                                            >
                                                {index === steps.length - 1 ? t('Finish') : t('Continue')}
                                            </MDButton>
                                            <MDButton
                                                variant={'text'}
                                                disabled={index === 0}
                                                onClick={handleBack}
                                                sx={{ mt: 1, mr: 1 }}
                                            >
                                                {t('Back')}
                                            </MDButton>
                                        </MDBox>
                                    </StepContent>
                                </Step>
                            ))}
                        </Stepper>
                        {/*{activeStep === steps.length && (*/}
                        {/*    <Paper square elevation={0} sx={{ p: 3 }}>*/}
                        {/*        <MDTypography>All steps completed - you&apos;re finished</MDTypography>*/}
                        {/*        <MDButton onClick={handleReset} sx={{ mt: 1, mr: 1 }}>*/}
                        {/*            Reset*/}
                        {/*        </MDButton>*/}
                        {/*    </Paper>*/}
                        {/*)}*/}
                    </MDBox>

                </DialogContentText>
            </DialogContent>

        </Dialog>
        <Dialog
            open={isAlertOpen}
            onClose={() => setIsAlertOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
        >
            <DialogTitle id="alert-dialog-title">
                <div>{t("Are you sure?")}</div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('Do you really want to delete row:')}
                    <span style={{color: 'red', padding: '10px', fontWeight: 'bold'}}>{currentDeletedObject?.id}</span>
                    ? {t('This process cannot be undone')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton onClick={() => {
                    setIsAlertOpen(false)
                }}>
                    {t('Disagree')}
                </MDButton>

                <MDButton onClick={() => {
                    setData(data.filter(item=>item.id !== currentDeletedObject.id))
                    setIsAlertOpen(false)
                    setCurrentDeletedObject(null)
                }}>{t('Agree')}</MDButton>
            </DialogActions>
        </Dialog>
    </React.Fragment>)
}

export default CustomerImportDialog